import React from 'react';

function AllyIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99984 4.16667V5.83333H16.6665C17.5832 5.83333 18.3332 6.58333 18.3332 7.5V15.8333C18.3332 16.75 17.5832 17.5 16.6665 17.5H3.33317C2.4165 17.5 1.6665 16.75 1.6665 15.8333V4.16667C1.6665 3.25 2.4165 2.5 3.33317 2.5H8.33317C9.24984 2.5 9.99984 3.25 9.99984 4.16667ZM3.33317 15.8333H4.99984V14.1667H3.33317V15.8333ZM4.99984 12.5H3.33317V10.8333H4.99984V12.5ZM3.33317 9.16667H4.99984V7.5H3.33317V9.16667ZM4.99984 5.83333H3.33317V4.16667H4.99984V5.83333ZM6.6665 15.8333H8.33317V14.1667H6.6665V15.8333ZM8.33317 12.5H6.6665V10.8333H8.33317V12.5ZM6.6665 9.16667H8.33317V7.5H6.6665V9.16667ZM8.33317 5.83333H6.6665V4.16667H8.33317V5.83333ZM9.99984 15.8333H15.8332C16.2915 15.8333 16.6665 15.4583 16.6665 15V8.33333C16.6665 7.875 16.2915 7.5 15.8332 7.5H9.99984V9.16667H11.6665V10.8333H9.99984V12.5H11.6665V14.1667H9.99984V15.8333ZM14.9998 9.16667H13.3332V10.8333H14.9998V9.16667ZM13.3332 12.5H14.9998V14.1667H13.3332V12.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default AllyIcon;
